import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from "vuex-persistedstate";
Vue.use(Vuex)

const store = new Vuex.Store({

  state: {
    courseInfo: '',
    allWarnList: [],
    value1: '',
    //空闲教室查询
    freeDate: '',
    freeNode: '',
    freeBuilding: '',
    freeCampus: '',
    // 教学评价
    evaTextList: [{
      evaText: ''
    }],
    //评价历史选项
    evaOptCheck: [],
    loadCheckList: [],
    // 首页权限菜单
    homeMenuList: [],
    level: '',

    // 顶岗实习全局状态参数
    sxjhid: '', // id
    isty: 0, // 统一还是分散
    timeRange: ['', ''],

    // 教师顶岗实习锁选学生列表
    studentData: [],
    formData: {}
  },
  getters: {
    getSxjhid: (state) => {
      return state.sxjhid
    },
    getIsty: (state) => {
      return state.isty
    },
    getTimeRange: (state) => {
      return state.timeRange
    },
    getStudentData: (state) => {
      return state.studentData
    },
    getFormData: (state) => {
      return state.formData
    },

  },
  mutations: {
    SET_SXJHID(state, id) {
      state.sxjhid = id
    },
    SET_ISTY(state, isty) {
      state.isty = isty
    },
    SET_TIMERANGE(state, timeRange) {
      state.timeRange = timeRange
    },
    SET_STUDENT_DATA(state,studentData) {
      state.studentData = studentData
    },
    SET_FORM_DATA(state,formData) {
      state.formData = formData
    },
  },
  actions: {
    setSxjhid({
      commit
    }, id) {
      commit('SET_SXJHID', id)
    },
    setIsty({
      commit
    }, isty) {
      commit('SET_ISTY', isty)
    },
    setTimeRange({
      commit
    }, timeRange) {
      commit('SET_TIMERANGE', timeRange)
    },
    setStudentData({
      commit
    }, studentData) {
      commit('SET_STUDENT_DATA', studentData)
    },
    setFormData({
      commit
    }, formData) {
      commit('SET_FORM_DATA', formData)
    }
  },
  plugins: [persistedState({
    storage: window.sessionStorage,
    reducer(val) {
      return {
        // 只储存state中的部分字段
        sxjhid: val.sxjhid,
        isty:  val.isty, // 统一还是分散
        timeRange: val.timeRange,
        studentData: val.studentData
      }
    }
  })]
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js